
import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "FolderStatus",

  props: {
    state: {
      type: String as () => "check" | "waiting" | "empty",
      default: "",
      validator: (val: string) => ["check", "waiting", "empty"].includes(val),
    },
    position: {
      type: String,
      default: "top",
      validator: (v: string) => ["top", "bottom", "left", "right"].includes(v),
    },
  },

  setup() {
    return {};
  },
});
